export default __webpack_public_path__ + "static/media/IconPoolManagement.76788f0e.svg";